import { Container, Stack, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { allIcons, appFonts } from "../../assets";

const infoLinks = [
  {
    title: "Terms",
    link: "term",
  },
  {
    title: "Privacy",
    link: "privacy",
  },
  {
    title: "Contact",
    link: "contact",
  },
];

const socialIcons = [
  // {
  //   icon: allIcons.youtubeSocialIcon,
  //   name: "youtube",
  //   link: "",
  // },
  // {
  //   icon: allIcons.facebookSocialIcon,
  //   name: "facebook",
  //   link: "",
  // },
  // {
  //   icon: allIcons.twitterSocialIcon,
  //   name: "twitter",
  //   link: "",
  // },
  {
    icon: allIcons.instagramSocialIcon,
    name: "instagram",
    link: "/instagram.com/loba4business/",
  },
  // {
  //   icon: allIcons.linkdinSocialIcon,
  //   name: "linkdin",
  //   link: "",
  // },
];

const CopyRight = () => {
  const renderInfoLinks = () => {
    return (
      <Stack direction={"row"} alignItems={"center"} gap={1.5}>
        {infoLinks?.map((val, ind) => {
          return (
            <Link
              key={ind}
              to={`/${val.link}`}
              target="_blank"
              style={{
                textDecoration: "none",
                color: "#475569",
                // fontFamily:appFonts.Poppins
              }}
            >
              {val.title}
            </Link>
          );
        })}
      </Stack>
    );
  };

  const renderSocialIcons = () => {
    return (
      <Stack direction={"row"} alignItems={"center"} gap={1.5}>
        {socialIcons?.map((val, ind) => {
          return (
            <Link key={ind} to={`/${val.link}`}>
              <img
                src={val.icon}
                alt={`${val.name}-icons`}
                width={val.name == "facebook" ? "100%" : 20}
                height={val.name == "facebook" ? "20px" : null}
              />
            </Link>
          );
        })}
      </Stack>
    );
  };
  return (
    <Container maxWidth={"lg"} sx={{ py: 3 }}>
      <Stack
        direction={{ sm: "row" }}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={1}
      >
        <Typography
          mt={0.5}
          variant="h3"
          fontSize={"1.813rem"}
          fontWeight={"600"}
          textAlign={"center"}
          color={"#FF1F1F"}
        >
          LOBA
        </Typography>
        <Stack
          direction={{ sm: "row" }}
          gap={{ xs: 1, sm: 3 }}
          alignItems={"center"}
        >
          {renderInfoLinks()}
          {renderSocialIcons()}
        </Stack>
      </Stack>
    </Container>
  );
};

export default CopyRight;
